<!--
 * @Author: Scarlett Xiao
 * @Date: 2021-12-21 19:42:09
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2021-12-29 14:41:26
-->

<template>
  <div class="container">
    <div class="content-box">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "container",
  props: {},
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  // 中间弹框
  .content-box {
    width: 126.75rem;
    height: 73.75rem;
    background-color: transparent;
    background: url("../../assets/pc/popup.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
